import * as React from "react";
import { useDebugControlPosition } from "./tools";
import DebugControls from "./DebugControls";
import { Box, useTheme } from "@mui/material";

export const DebugControlContainer = () => {
    const { position } = useDebugControlPosition();
    const theme = useTheme();

    return (
        <Box
            sx={{
                position: "fixed",
                zIndex: theme.zIndex.modal + 1,
                transition: "all 0.5s cubic-bezier(0.61, 0.14, 0, 1)",
                ...position,
            }}
        >
            <DebugControls />
        </Box>
    );
};
